// AWS Configs
export const RESOURCE_URL='https://kickavenue-assets.s3.amazonaws.com/';
export const RESOURCE_URL_DEV='https://kickavenue-develop.s3.amazonaws.com/';
export const RESOURCE_URL_USER='https://kickavenue-user-uploads.s3.amazonaws.com/';

// Image URL
export const USER_UPLOAD_IMAGE = 'https://d1i34sodava61.cloudfront.net';
export const ASSET_IMAGE = 'https://d3jneea6mhvdzo.cloudfront.net';
export const SIZE_CHART_IMAGE = 'https://s3-ap-southeast-1.amazonaws.com/kickavenue.com/asset-images/Size+Charts';
export const SELLING_COMMISSION_IMAGE = 'https://s3.ap-southeast-1.amazonaws.com/kickavenue.com/dashboard';

// Image Cache
export const getCacheImage = (url) => {
  if(!url || url === "" || typeof url !== "string")
    return url;
    
  return url
    .replace(/kickavenue-user-uploads.s3([\.|-][^\.]+)?.amazonaws.com/, "d1i34sodava61.cloudfront.net")
    .replace(/kickavenue-assets.s3([\.|-][^\.]+)?.amazonaws.com/, "d3jneea6mhvdzo.cloudfront.net")
    

}

//minimum kick credit deposit to make an offer
export const OFFER_DEDUCT = 25000;
export const VALIDATE_AMOUNT_DELAY = 3000;
export const OFFER_DEPOSIT = 0;
export const OFFER_GAP = 50000;
export const ASKING_PRICE = 50000;
export const SUPPORTED_IMG_FORMATS = ['jpg', 'jpeg', 'png', 'gif', 'svg'];
